import { render } from "./VnfAppliancesTab.vue?vue&type=template&id=e8a3d63e&scoped=true"
import script from "./VnfAppliancesTab.vue?vue&type=script&lang=js"
export * from "./VnfAppliancesTab.vue?vue&type=script&lang=js"

import "./VnfAppliancesTab.vue?vue&type=style&index=0&id=e8a3d63e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a3d63e"]])

export default __exports__